import { downloadFilePost, get, post, put } from 'utils/api';

import { DataResponse } from '../response';
import { MASTER_DATA_API_URL } from 'utils/constants';

export type WasteProductModel = {
  stt?: number;
  wasteProductId?: string;
  productCode: string;
  productName: string;
  wasteGroupingEnvironmentPermitId?: string;
  wasteGroupingEnvironmentPermitName?: string;
  wasteGroupingEnvironmentPermitCustomCode?: string;
  wasteGroupingContractId?: string;
  wasteGroupingContractName?: string;
  wasteGroup?: string;
  actived: boolean;
  createBy?: string;
  createByName?: string;
  createTime?: string;
}

export interface IWasteProductServices {
  // search waste product list
  searchWasteProducts(data: object): Promise<DataResponse<Array<WasteProductModel>>>;
  // create waste product
  createWasteProduct(data: object): Promise<DataResponse>;
  // update waste product
  updateWasteProduct(data: object): Promise<DataResponse>;
  getDetailWasteProduct(wasteProductId: string): Promise<DataResponse<WasteProductModel | undefined>>;
  // export template
  exportWasteProductTemplate(data: object): Promise<void>;
  // export data for create new waste products
  exportWasteProducts(data: object): Promise<void>;
  // import create new waste products from excel
  importWasteProductsCreate(file: File): Promise<DataResponse<any>>;
  // update status waste product
  updateWasteProductStatus(data: object): Promise<DataResponse<null>>;

  exportTemplateUpdateRequireConfirmPlan(data: object): Promise<void>;
  importWasteProductsUpdate(file: File): Promise<DataResponse<any>>;
}

export function createWasteProductServices(): IWasteProductServices {
  return {
    searchWasteProducts: async (data) => {
      return (await post(MASTER_DATA_API_URL, `wasteproduct/search`, data)).data;
    },
    createWasteProduct: async (data) => {
      return (await post(MASTER_DATA_API_URL, `wasteproduct/create`, data)).data;
    },
    updateWasteProduct: async (data) => {
      return (await put(MASTER_DATA_API_URL, `wasteproduct/update`, data)).data;
    },
    getDetailWasteProduct: async (id) => {
      return (await get(MASTER_DATA_API_URL, `wasteproduct/${id}`)).data;
    },
    exportWasteProductTemplate: async (data) => {
      await downloadFilePost(MASTER_DATA_API_URL, `wasteproduct/export-template`, data);
    },
    exportWasteProducts: async (data) => {
      await downloadFilePost(MASTER_DATA_API_URL, `wasteproduct/export`, data);
    },
    importWasteProductsCreate: async (file) => {
      const formData = new FormData();
      formData.append('file', file);
      return (await post(MASTER_DATA_API_URL, `wasteproduct/import-create`, formData)).data;
    },
    updateWasteProductStatus: async (data) => {
      return (await put(MASTER_DATA_API_URL, `wasteproduct/update-status`, data)).data as DataResponse<null>;
    },

    exportTemplateUpdateRequireConfirmPlan: async (data) => {
      await downloadFilePost(MASTER_DATA_API_URL, `wasteproduct/export-template-update-require-confirm-plan`, data);
    },

    importWasteProductsUpdate: async (file) => {
      const formData = new FormData();
      formData.append('file', file);
      return (await post(MASTER_DATA_API_URL, `wasteproduct/import`, formData)).data;
    },
  };
}

